// The ask card (#panel6) answering on the page, without a reload. MAR-21.
//
// Progressive: the form is still a plain POST that lands back on the card, so
// with no JavaScript or no fetch nothing changes. With it, submit shows the
// waiting box straight away, posts the same form data as JSON, and swaps in the
// box the server rendered (products/show/_ask_answer) — the markup for answered
// and not-answered lives in that one partial, not here.

const IDLE_LABEL = 'Get an instant answer';
const WAITING_LABEL = 'Finding your answer…';
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const init = () => {

	const card = document.getElementById( 'panel6' );
	const form = card && card.querySelector( '[data-ask-form]' );
	if( !form || !window.fetch || !window.FormData ) return;

	const answers = card.querySelector( '[data-ask-answers]' );
	const waiting = card.querySelector( '[data-ask-waiting]' );
	const error = form.querySelector( '[data-ask-error]' );
	const submit = form.querySelector( '[type=submit]' );
	const field = ( name ) => form.elements[ `product_question[${ name }]` ];

	// Our own messages replace the browser's bubbles; without JS those still apply.
	form.noValidate = true;

	const showError = ( message ) => {
		error.textContent = message || '';
		error.hidden = !message;
	};

	const setWaiting = ( on ) => {
		form.classList.toggle( 'is-waiting', on );
		Array.from( form.elements ).forEach( ( element ) => { element.disabled = on; } );
		submit.value = on ? WAITING_LABEL : IDLE_LABEL;
	};

	// Idle again: the question and the box go, the contact details stay.
	const askAnother = () => {
		answers.innerHTML = '';
		form.hidden = false;
		field( 'question' ).value = '';
		field( 'question' ).focus();
	};

	// The widget on desktop; on mobile it lives in the #booking-modal reveal.
	const book = () => {
		const widget = document.querySelector( '.product-view__booking' );
		if( widget && widget.offsetParent !== null ) {
			widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
		} else if( window.jQuery ) {
			window.jQuery( '#booking-modal' ).foundation( 'open' );
		}
	};

	const validate = () => {
		if( !field( 'question' ).value.trim() ) return 'Type your question first.';
		if( !field( 'name' ).value.trim() ) return 'Add your name so we know who to reply to.';
		if( !EMAIL.test( field( 'email' ).value.trim() ) ) return 'Add a valid email address — the team replies there if we can\'t answer instantly.';
		return null;
	};

	// Answers already on the page (a refresh, or back from another page) are the
	// answered state, which has no form until they ask another.
	if( answers.children.length ) form.hidden = true;

	// Book now / Enquire now on an availability answer reloads the page with the day
	// and group size in the URL for the booking panel to prefill, and #book to open
	// it. After load, so Foundation's reveal is ready to open on mobile. MAR-22.
	if( window.location.hash === '#book' ) {
		if( document.readyState === 'complete' ) book();
		else window.addEventListener( 'load', book );
	}

	card.addEventListener( 'click', ( event ) => {
		if( event.target.closest( '[data-ask-again]' ) ) {
			event.preventDefault();
			askAnother();
		} else if( event.target.closest( '[data-ask-book]' ) ) {
			// A prefilled link goes to the page it prefills, unless that is this page
			// already, where following it would be a jump to #book that opens nothing.
			const link = event.target.closest( '[data-ask-book]' );
			if( link.search && link.search !== window.location.search ) return;
			event.preventDefault();
			book();
		}
	});

	form.addEventListener( 'submit', ( event ) => {

		event.preventDefault();

		const problem = validate();
		showError( problem );
		if( problem ) return;

		// Collected before the fields are disabled, which drops them from FormData.
		const data = new FormData( form );

		answers.innerHTML = waiting.innerHTML;
		answers.querySelector( '[data-ask-echo]' ).textContent = field( 'question' ).value.trim();
		setWaiting( true );

		fetch( form.action, {
			method: 'POST',
			body: data,
			credentials: 'same-origin',
			headers: { Accept: 'application/json' }
		})
			.then( ( response ) => ( response.ok || response.status === 422 ? response.json() : Promise.reject( response ) ) )
			.then( ( json ) => {
				setWaiting( false );
				if( json.error ) {
					answers.innerHTML = '';
					showError( json.error );
					return;
				}
				answers.innerHTML = json.html;
				form.hidden = true;
			})
			// ponytail: fall back to the plain POST, which lands on the same card. If the
			// failed request did reach the server the team gets the question twice, which
			// beats a guest whose question went nowhere.
			.catch( () => {
				setWaiting( false );
				answers.innerHTML = '';
				form.submit();
			});
	});
};

if( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
